import { render, staticRenderFns } from "./DirectDebit.vue?vue&type=template&id=351d80b6"
import script from "./DirectDebit.vue?vue&type=script&lang=js"
export * from "./DirectDebit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports